<template>
  <v-card>
    <v-card-title class="pa-0">
      <v-toolbar dense color="red lighten-1">
        <v-toolbar-title class="white--text">Funções</v-toolbar-title>
      </v-toolbar>
    </v-card-title>
    <v-card-text>
      <FunctionsList />
    </v-card-text>
  </v-card>
</template>

<script>
import FunctionsList from './components/FunctionsList.vue'
export default {
  name: 'FunctionsAdmin',
  components: {
    FunctionsList,
  },
  data: function () {
    return {
      dialog: false,
    }
  },
  computed: {},
  methods: {},
}
</script>
